module.exports = __webpack_public_path__ + "static/media/user-plus.4138d1fb.svg";